import { connection } from '@/api/connection'

export default {
  getCustomFields: () => connection.get('/custom-fields'),
  getCustomField: ({ id }) => connection.get(`/custom-fields/${id}`),
  postCustomField: ({ customFieldData }) => connection.post('/custom-fields', customFieldData),
  putCustomField: ({ id, customFieldData }) => connection.put(`/custom-fields/${id}`, customFieldData)
}
